<template>
    <v-dialog v-model="open" max-width="720" :persistent="saving">
        <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" outlined class="mb-4" v-bind="attrs" v-on="on" data-test="steffi-open-offline-trial">
                Offline-Testphase erfassen
            </v-btn>
        </template>
        <v-card>
            <v-card-title>Offline-Testphase erfassen</v-card-title>
            <v-card-text>
                <p>
                    Wählen Sie die Apotheke aus, deren Testphase außerhalb der Plattform stattfindet.
                    Die Kennzeichnung blendet die FPP-Testphase aus und verhindert weitere FPP-Testbuchungen.
                    Eine angefragte oder laufende FPP-Testphase wird beendet. Kostenpflichtige Buchungen bleiben unverändert.
                </p>
                <v-alert v-if="error" type="error" outlined dense>{{ error }}</v-alert>
                <v-text-field
                    v-model="search"
                    label="Apotheke suchen"
                    maxlength="100"
                    hint="Mindestens 2 Zeichen: Name, Kundennummer, Postleitzahl oder Ort"
                    persistent-hint
                    :disabled="loading || saving"
                    data-test="steffi-offline-search"
                    @keyup.enter="findPharmacies"
                />
                <v-btn
                    outlined
                    :disabled="search.trim().length < 2 || loading || saving"
                    :loading="loading"
                    data-test="steffi-offline-search-submit"
                    @click="findPharmacies"
                >Suchen</v-btn>
                <template v-if="items">
                    <p v-if="!items.length && !loading" class="mt-4">Keine Apotheken gefunden.</p>
                    <v-radio-group v-model="selected" :disabled="loading || saving">
                        <v-radio
                            v-for="item in items"
                            :key="item.pharmacy_id"
                            :value="item"
                            :disabled="item.steffi_offline_trial"
                        >
                            <template v-slot:label>
                                <div>
                                    <strong>{{ item.name }}</strong>
                                    <div>{{ item.customer_id || item.pharmacy_id }} · {{ item.zip }} {{ item.city }}</div>
                                    <span v-if="item.steffi_offline_trial">Offline-Testphase bereits erfasst</span>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                    <p v-if="items.length === 20" class="text-caption">Es werden höchstens 20 Treffer angezeigt. Bitte grenzen Sie die Suche bei Bedarf ein.</p>
                </template>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text :disabled="saving" @click="open = false">Schließen</v-btn>
                <v-btn
                    color="primary"
                    :disabled="!selected || selected.steffi_offline_trial || loading || saving"
                    :loading="saving"
                    data-test="steffi-offline-save"
                    @click="save"
                >Offline-Testphase erfassen</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    data: () => ({
        open: false,
        search: '',
        items: null,
        selected: null,
        loading: false,
        saving: false,
        error: '',
    }),
    methods: {
        async findPharmacies() {
            if (this.search.trim().length < 2 || this.loading || this.saving) return;
            this.loading = true;
            this.error = '';
            this.selected = null;
            this.items = null;
            try {
                const response = await axios.get('/api/steffi/customers', {
                    params: { view: 'offline_trials', search: this.search.trim() },
                });
                this.items = response.data.items;
            } catch (error) {
                this.error = error?.response?.data?.message || 'Apotheken konnten nicht geladen werden.';
            } finally {
                this.loading = false;
            }
        },
        async save() {
            if (!this.selected || this.selected.steffi_offline_trial || this.loading || this.saving) return;
            this.saving = true;
            this.error = '';
            try {
                await axios.put(`/api/pharmacies/${this.selected.pharmacy_id}/steffi/admin-context`, {
                    steffi_offline_trial: true,
                });
                this.$set(this.selected, 'steffi_offline_trial', true);
                this.$emit('saved');
            } catch (error) {
                this.error = error?.response?.data?.message || 'Offline-Testphase konnte nicht gespeichert werden.';
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
